import { useMatchCurrentPage } from './useMatchCurrentPage';
import { usePathSet } from './usePathSet';

export const useIsPlotPage = () => {
  const pathSet = usePathSet();
  return useMatchCurrentPage([
    pathSet.plot,
    pathSet.plotLandMonitoring,
    pathSet.plotOverview,
    pathSet.plotInteractiveMap,
  ]);
};
